import './sideImg.scss'

function SideImg() {
  return (
    <div className="left">
      <img id="test" src="/img/image1.png" />
      <a href="/cv.pdf" target="_blank" rel="noreferrer" className="cv-pdf-btn">
        <img src="/img/icons/cv.svg" className="cv-pdf-icon" alt="CV" />
        Télécharger mon CV
      </a>
    </div>
  );
}

export default SideImg;
